import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { compact } from 'lodash-es';
import { FunctionalLoader, DeclarativeModal } from 'seagull';
import { useOverlayContext, useStore, useStoreActions, useStoreStatic } from '~/contexts';
import { useContacts } from '~/hooks/reactQuery/queries/useContacts';
import { useProposals } from '~/hooks/reactQuery/queries/useProposals';
import { useOnMount } from '~/hooks/useOnMount';
import { selectors } from '~/store/state-selectors';
import { makeSentryIgnoredError } from '../../ErrorBoundaryPage';
import { AgreementStudioTemplateMode } from './AgreementStudioTemplateMode';
export default function AgreementStudioTemplates(props) {
    const { startLoader, stopLoader } = useOverlayContext();
    const { fetchAgreements, fetchLegalTerms, fetchFinancialCentsUsers, fetchKarbonUsers } = useStoreActions();
    const { isLoading } = useContacts({
        refreshOnMount: true
    });
    const { refresh: fetchProposals } = useProposals();
    const { getState } = useStoreStatic();
    const legalTermsDocuments = useStore((state)=>state.legalTerms.data);
    const worksAt = useStore(selectors.user.business);
    const userEmail = useStore(selectors.user.email);
    useOnMount(()=>{
        startLoader('AgreementStudioTemplates');
        const requests = compact([
            fetchLegalTerms(),
            fetchAgreements(),
            fetchProposals(),
            selectors.integration.showFinancialCentsIntegration(getState()) && fetchFinancialCentsUsers(),
            selectors.integration.showKarbonIntegration(getState()) && fetchKarbonUsers()
        ]);
        Promise.all(requests).then(()=>stopLoader('AgreementStudioTemplates'));
    });
    if (!worksAt || !userEmail) throw makeSentryIgnoredError('noBusiness');
    return legalTermsDocuments ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FunctionalLoader, {
                show: isLoading,
                name: "clientsLoader"
            }),
            /*#__PURE__*/ _jsx(DeclarativeModal, {
                biName: "agreement_studio_templates",
                isOpen: true,
                treatAsPage: true,
                content: ()=>/*#__PURE__*/ _jsx(AgreementStudioTemplateMode, _object_spread_props(_object_spread({}, props), {
                        template: props.template || null,
                        worksAt: worksAt,
                        userEmail: userEmail
                    }))
            })
        ]
    }) : /*#__PURE__*/ _jsx(FunctionalLoader, {
        show: true,
        name: "AgreementStudioTemplates"
    });
}
